import { APP_DRAWIO_URL } from "../../../services/api/constants";
import { SchemasValue } from "../../../services/api/instances/schemasApi/types";
import { TSchemaExportExtensions } from "../types";

export const SCHEMA_AGENT_REF =
  "7dd63a848bdcba0200f0487c16e96b485e0e72b9e957d5fa969e3d943c586239b660a6f8758518448ff5bdf296356aee29e9f77c9e4b03e440a87ee2ddf6ad1f";

export const DRAWIO_ORIGIN = APP_DRAWIO_URL;

export const DRAWIO_INITIAL_EMBED_URI = `${APP_DRAWIO_URL}/?embed=1&configure=1&lang=ru&ui=min&spin=1&proto=json`;

export const DRAWIO_VIEWER_URI = "https://viewer.diagrams.net";

export const INITIAL_XML = `<mxGraphModel dx="1024" dy="568" grid="1" gridSize="10" guides="1" tooltips="1" connect="1" arrows="1" fold="1" page="1" pageScale="1" pageWidth="1600" pageHeight="900" math="0" shadow="0">
  <root>
    <mxCell id="0"/>
    <mxCell id="1" parent="0"/>
    <mxCell id="2" value="Создайте новую Схему" style="rounded=0;whiteSpace=wrap;html=1;" vertex="1" parent="1">
      <mxGeometry x="600" y="415" width="160" height="70" as="geometry"/>
    </mxCell>
    <mxCell id="3" value="Draw.io" style="ellipse;whiteSpace=wrap;html=1;" vertex="1" parent="1">
      <mxGeometry x="840" y="400" width="160" height="100" as="geometry"/>
    </mxCell>
    <mxCell id="4" value="" style="endArrow=classic;html=1;exitX=1;exitY=0.5;entryX=0;entryY=0.5;" edge="1" parent="1" source="2" target="3">
      <mxGeometry width="50" height="50" relative="1" as="geometry">
        <mxPoint x="600" y="450" as="sourcePoint"/>
        <mxPoint x="840" y="450" as="targetPoint"/>
      </mxGeometry>
    </mxCell>
  </root>
</mxGraphModel>`;

export const INITIAL_SCHEMA_VALUE: SchemasValue = {
  schemas_object: {
    schema_url: DRAWIO_INITIAL_EMBED_URI,
    schema_xml: INITIAL_XML,
    settings: {
      ui: "",
    },
    messages: [],
  },
  metadata: {
    thread_ref: null,
    mode: "generate_schema",
  },
};

export const EXPORT_SCHEMA_MENU_ACTIONS = [
  {
    id: 1,
    name: "Экспортировать в drawio",
    extension: "drawio" as TSchemaExportExtensions,
  },
  {
    id: 2,
    name: "Экспортировать в PNG",
    extension: "png" as TSchemaExportExtensions,
  },
];
